<div
  class="notification-backdrop"
  *ngIf="backdrop && checkBackdrop(backdrop);"
  [style.opacity]="backdrop"></div>
<div
  *ngFor="let position of notifications | keys"
  class="notification notification-{{position}}">
  <xm-notification-toast
    *ngFor="let notification of notifications[position] | slice:blockSizeA:blockSizeB"
    [toast]="notification"
    (stateChanged)="stateChanged($event)">
  </xm-notification-toast>
</div>
